module.exports = "<div class=\"savedsearch-create form-field\" ng-show=hasFilters()> <button ng-click=saveSearch() ng-show=$root.loggedin class=button-alpha type=button translate> set.save_savedsearch </button> <button ng-click=clearFilters() class=button-link type=button translate> set.clear_search </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/savedsearches/savedsearch-create.html
// module id = 788
// module chunks = 0